<template>
  <div class="broken-line">
    <div class="chart-wrap">
      <div class="chart-header flex-wrap">
        <div class="main-font-color title">{{ title }}</div>
      </div>
      <div class="chart-body flex-wrap">
        <div ref="chart" class="chart-content" />
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'BrokenLine',
  props: {
    queryData: Array,
    title: String,
    count: Array,
    type: String,
    name: String
  },
  data() {
    return {
      dateList: [],
      valueList: [],
      priceList: []
    }
  },
  watch: {
    queryData() {
      this.initData()
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      this.dateList = this.queryData.map(item => {
        return item.date
      })
      this.valueList = this.queryData
      this.priceList = []
      for (let i = 0; i < this.valueList.length; i++) {
        this.valueList[i].value.value1 =
          this.valueList[i].value.target[this.name] || 0
        this.valueList[i].value.value2 = 0
        for (const key in this.valueList[i].value.total) {
          if (this.count.indexOf(key) > -1) {
            this.valueList[i].value.value2 += Number(
              this.valueList[i].value.total[key]
            )
          }
        }
        if (this.type == 'price') {
          // this.valueList[i].value.value1 = (this.valueList[i].value.value1)/100;
          this.valueList[i].value.value2 = this.valueList[i].value.value2 / 100
        }
        this.valueList[i].value.value2 = this.valueList[i].value.value2 || 0
        this.valueList[i].value.value = (
          (this.valueList[i].value.value2 / this.valueList[i].value.value1) *
          100
        ).toFixed(2)
        if (
          this.valueList[i].value.value1 == 0 &&
          this.valueList[i].value.value2 != 0
        ) {
          this.valueList[i].value.value = 100
        }
        if (
          this.valueList[i].value.value1 == 0 &&
          this.valueList[i].value.value2 == 0
        ) {
          this.valueList[i].value.value = 0
        }
        this.priceList.push(this.valueList[i].value.value)
      }
      this.drawPie()
    },
    drawPie() {
      const pie = echarts.init(this.$refs.chart)
      pie.setOption({
        visualMap: [
          {
            show: false,
            type: 'continuous',
            seriesIndex: 1,
            dimension: 0,
            min: 0,
            max: this.dateList.length - 1
          }
        ],
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#4c84ff',
          formatter: function(params) {
            return '完成率：' + params[0].value + '%'
          }
          // formatter : function(params, ticket, callback) {
          //   return  "完成率："+ params[0].data.value.value + '%' + "<br />"
          //           + "目标："+ params[0].data.value.value1 + "<br />"
          //           + "已核算："+ params[0].data.value.value2;
          // }
        },
        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#bbb'
            }
          },
          data: this.dateList
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#bbb'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#f2f2f2'
            }
          }
        },
        series: [
          {
            type: 'line',
            showSymbol: false,
            smooth: true,
            itemStyle: {
              normal: {
                color: '#386db3',
                lineStyle: {
                  color: '#4c84ff'
                }
              }
            },
            data: this.priceList
          }
        ]
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.chart-wrap {
  margin-bottom: 50px;
  width: 760px;
  .chart-header {
    background-color: #f0f3fa;
    height: 60px;
    line-height: 60px;
    padding: 0 30px;
    justify-content: space-between;
    .title {
      font-size: 16px;
    }
    .total {
      font-size: 14px;
    }
  }
  .chart-body {
    height: 350px;
    background-color: #fafafa;
    .chart-content {
      width: 760px;
      height: 350px;
      div {
        width: 100px !important;
      }
    }
    .item-list {
      flex: 1;
      height: 100%;
      padding: 85px 50px;
      box-sizing: border-box;
      justify-content: space-between;
      align-content: space-between;
      flex-wrap: wrap;
      position: relative;
      :before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(0, -50%);
        width: 2px;
        height: 180px;
        background-color: #d9d9d9;
      }
      .item-content {
        width: 50%;
        .item-icon {
          box-sizing: border-box;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          border-width: 3px;
          border-style: solid;
          border-color: #333;
        }
        .item-info {
          overflow: hidden;
          padding-left: 10px;
          font-size: 14px;
          .item-title {
            color: $color_black;
            margin-bottom: 10px;
          }
          .item-total {
            color: $color_normal;
          }
        }
      }
    }
  }
}
</style>
